<template>
	<main class="vx-row mb-8">
		<div class="vx-col w-full md:w-1/2">
			<div style="position: relative;">
				<vs-button	
					class="cursor-pointer p-4 rounded-bl-none rounded-tl-none z-50 text-white"
					style="position: absolute;top: 0;right:0;"
					icon-pack="feather"
                    icon="icon-search"
				>
				</vs-button>
				<div id="nominal">
					<vs-input
						class="w-full rounded-tl-none rounded-bl-none"
						v-model="nominal"
						placeholder="Cari Transaksi"
					/>	
				</div>
				
			</div>
		</div>

		<div class="vx-col hidden md:block md:w-1/2 lg:w-1/4">
			<v-select
				v-model="category"
				:options="categoryOptions"
				class="w-full"
			/>
		</div>	
		<div class="vx-col hidden lg:block md:w-1/4">
			<vs-input
				type="date"
				icon-pack="feather"
				icon="icon-calendar"
				v-model="date"
			/>
		</div>
	</main>
</template>
<script>
	import vSelect from 'vue-select'
	export default {
		components: {
			vSelect
		},
		data: () => ({
			date: null,
			nominal: 0,
			category: {
				label: 'Semua'
			},
			categoryOptions: [
				{
					id:'0',
					label: 'Semua Kategori'
				},
				{
					id: 1,
					label: 'Campaign'
				},
				{
					id: 3,
					label: 'PPOB'
				},
				{
					id: 2,
					label: 'ZIS'
				}
			]
		})
	}
</script>